import * as React from 'react';
import {
    Box as StyledBox,
    BoxProps as StyledBoxProps,
    PseudoBox,
    PseudoBoxProps
} from '@chakra-ui/core';

interface BoxProps extends StyledBoxProps {
    anchor?: string
}

interface FixedProps extends BoxProps {}

const Box: React.FC<BoxProps> = (
    React.forwardRef((props: BoxProps, ref: React.ElementRef<any>) => (
        <StyledBox ref={ref} {...props} />
    ))
);

const Fixed: React.FC<FixedProps> = (
    React.forwardRef((props: FixedProps, ref: React.ElementRef<any>) => (
        <StyledBox position="fixed" ref={ref} {...props} />
    ))
);

export {
    Fixed,
    PseudoBox,
    BoxProps,
    PseudoBoxProps,
    FixedProps
};

export default Box;
